import React from 'react';

interface SkeletonProps {
  className?: string;
  width?: string | number;
  height?: string | number;
  borderRadius?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({ 
  className = "", 
  width, 
  height, 
  borderRadius 
}) => {
  return (
    <div 
      className={`skeleton-pulse ${className}`}
      style={{ 
        width: width || '100%', 
        height: height || '1rem',
        borderRadius: borderRadius || '0.5rem'
      }}
    />
  );
};

export const SkeletonCard: React.FC<{ className?: string }> = ({ className = "" }) => (
  <div className={`glass-card p-4 space-y-4 ${className}`}>
    <div className="flex items-center gap-3">
      <Skeleton width={40} height={40} borderRadius="50%" />
      <div className="space-y-2 flex-1">
        <Skeleton width="60%" height="0.875rem" />
        <Skeleton width="40%" height="0.75rem" />
      </div>
    </div>
    <Skeleton width="100%" height="2rem" />
    <div className="flex justify-between items-center pt-2">
      <Skeleton width="30%" height="1.25rem" />
      <Skeleton width="20%" height="1.25rem" />
    </div>
  </div>
);

export const SkeletonRow: React.FC<{ className?: string }> = ({ className = "" }) => (
  <div className={`flex items-center justify-between p-4 border-b border-white/5 ${className}`}>
    <div className="flex items-center gap-3 flex-1">
      <Skeleton width={32} height={32} borderRadius="50%" />
      <Skeleton width="50%" height="1rem" />
    </div>
    <Skeleton width="20%" height="1.25rem" />
  </div>
);

export const SkeletonDashboard: React.FC = () => (
  <div className="space-y-6 animate-pulse">
    <div className="grid grid-cols-2 gap-4">
      <Skeleton height="6rem" className="glass-card" />
      <Skeleton height="6rem" className="glass-card" />
    </div>
    <div className="space-y-4">
      <Skeleton width="40%" height="1.5rem" className="ml-1" />
      <div className="grid grid-cols-1 gap-3">
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
      </div>
    </div>
  </div>
);

export const SkeletonLeaderboard: React.FC = () => (
  <div className="space-y-8">
    <div className="flex items-end justify-center gap-4 h-48 px-2">
      <Skeleton height="70%" className="w-24 podium-card" />
      <Skeleton height="100%" className="w-28 podium-card" />
      <Skeleton height="60%" className="w-24 podium-card" />
    </div>
    <div className="space-y-2">
      {[1, 2, 3, 4, 5].map(i => (
        <SkeletonRow key={i} />
      ))}
    </div>
  </div>
);
